export default __webpack_public_path__ + "static/media/milan.8f7f1001.png";